const adminList = () => import('@/pages/permission/admin/index.vue');
const adminForm = () => import('@/pages/permission/admin/form.vue');

export default [{
    path: '/permission/admin/list',
    component: adminList,
    meta: [{
        name: '权限管理'
    },
    {
        name: '管理员列表',
        activeRoute: '/permission/admin/list'
    }]
}, {
    path: '/permission/admin/form',
    component: adminForm,
    meta: [{
        name: '权限管理'
    },
    {
        name: '管理员列表',
        url: '/permission/admin/list',
    },
    {
        name: '添加/编辑',
        activeRoute: '/permission/admin/list'
    }]
}];